// extracted by mini-css-extract-plugin
module.exports = {"seamless-tech":"styles_seamless-tech__2gkKM"};